import {
  Actions,
  AmountCell,
  Badge,
  DateCell,
  formatDate,
  IndexCell,
  NameCell,
  PhoneCell,
  SubduedCell,
  ToggleActiveStatus,
} from "@";

const PAYMENT_INTERVAL_MAP = {
  0: "يومي",
  1: "إسبوعي",
  2: "شهري",
  3: "كل ٣ شهور",
  4: "كل ٦ شهور",
  5: "سنوي",
};

// Next payment is the upcoming action — give it a soft purple chip so it
// stands out from regular dates without being noisy.
const NextPaymentCell = ({ value }) => {
  if (!value) {
    return <span className="text-xs text-gray-300 dark:text-gray-600">—</span>;
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-purple-50 px-2.5 py-0.5 text-[12px] font-semibold tabular-nums text-purple-900 ring-1 ring-purple-100 dark:bg-purple-950/40 dark:text-purple-300 dark:ring-purple-800/40">
      <span
        aria-hidden
        className="h-1.5 w-1.5 rounded-full bg-purple-500 dark:bg-purple-400"
      />
      {formatDate(value)}
    </span>
  );
};

export const TableActions = ({ row, toggleActive }) => {
  return (
    <Actions notShow row={row} notDelete notEdit>
      <ToggleActiveStatus row={row} click={toggleActive} />
    </Actions>
  );
};

// TanStack columns
export const tableColumns = [
  {
    id: "rowIndex",
    header: "م",
    size: 60,
    cell: ({ row }) => <IndexCell value={row.index + 1} />,
  },
  {
    id: "projectName",
    header: "المشروع",
    size: 180,
    cell: ({ row }) => <NameCell name={row.original.projectName} />,
  },
  {
    id: "attributeName",
    header: "الفئة",
    size: 140,
    cell: ({ row }) => <SubduedCell value={row.original.attributeName} />,
  },
  {
    id: "donorName",
    header: "اسم المتبرع",
    size: 180,
    cell: ({ row }) => <NameCell name={row.original.donorName} />,
  },
  {
    id: "phoneNumber",
    header: "رقم الجوال",
    size: 140,
    cell: ({ row }) => <PhoneCell phone={row.original.phoneNumber} />,
  },
  {
    id: "amount",
    header: "مبلغ الاستقطاع",
    size: 120,
    cell: ({ row }) => <AmountCell value={row.original.amount} />,
  },
  {
    id: "startRecurringAt",
    header: "تاريخ البداية",
    size: 120,
    cell: ({ row }) => <DateCell value={row.original.startRecurringAt} />,
  },
  {
    id: "nextPaymentAt",
    header: "الدفعة القادمة",
    size: 130,
    cell: ({ row }) => <NextPaymentCell value={row.original.nextPaymentAt} />,
  },
  {
    id: "paymentInterval",
    header: "مدة الاستقطاع",
    size: 120,
    cell: ({ row }) => (
      <Badge title={PAYMENT_INTERVAL_MAP[row.original.paymentInterval] || ""} />
    ),
  },
  {
    id: "isStopped",
    header: "الحالة",
    size: 80,
    cell: ({ row }) => (
      <Badge
        title={row.original.isStopped ? "غير فعال" : "فعال"}
        color={row.original.isStopped ? "red" : "green"}
      />
    ),
  },
];
